import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import { inject, observer } from 'mobx-react'
import config from 'react-global-configuration';

import { Section, GridRow, Heading1 } from '../marketing/MarketingStyles';

@inject('utilStore', 'translationStore')
@observer
class PartnerSection extends Component {

  constructor(props) {
    super(props)
    this.state = {
      index: 0
    }
  }

  handleCarouselChange = (index, partners) => {
    const { isTablet, isPhone } = this.props.utilStore
    if(!partners) return

    const offset = isTablet ? isPhone ? 0 : 1 : 2

    const newIndex = index + offset > partners.length ? 0 : index - offset

    this.setState( { index: newIndex } )
  }

  render() {

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    const { partners } = this.props.utilStore
    const { isTablet, isPhone } = this.props.utilStore

    const itemsPerPage = isTablet ? isPhone ? 1 : 3 : 5

    const numberOfItems = partners && partners.length
    const notEnoughEntries = partners && numberOfItems < itemsPerPage

    // if(notEnoughEntries) {
    //   for (var i = 0; i < itemsPerPage - partners.length; i++) {
    //     partners.push({ isPlaceholder: true })
    //   }
    // }

    const newIndex = isTablet ? isPhone ? this.state.index : this.state.index + 1 : this.state.index + 2

    return (
      <Section id="partners">
        <Heading1>{ text('marketing_partner_headline') }</Heading1>
        <PartnerCarousel
          swipeable={ !notEnoughEntries } autoPlay={ !notEnoughEntries } interval={4000} stopOnHover={false} infiniteLoop={true} centerMode centerSlidePercentage={ isTablet ? isPhone ? "100" : "33.3" : "20" } showArrows={false} showStatus={false} showIndicators={false} showThumbs={false}
          onChange={ index => this.handleCarouselChange(index, partners) }
          selectedItem={ newIndex }
        >
          { partners && partners.map((item, index) => {
            return item.isPlaceholder ?
              <div></div>
              :
              <PartnerItem href={ item.location } target="_blank">
                <PartnerLogo src={`${config.get('DIRECTUS_BACKEND')}assets/${ item.logo.id }?key=medium`} alt={ item.name }/>
              </PartnerItem>
          })}
        </PartnerCarousel>
      </Section>
    )
  }
}

export default PartnerSection

const PartnerCarousel = styled(Carousel) `

`
const PartnerGrid = styled.div `
  padding: 50px 0;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;

  > * {
    width: calc(100% / 6 - 20px);
    margin: 0 10px;
    display: inline-block;
  }
`

const PartnerItem = styled.a `
  height: 100%;
  transition: all ${ cssVar.transitions.basic };

  :hover {
    transform: scale(1.1);
  }
`

const PartnerLogo = styled.img `
  width: 100%;
  height: 80%;
  padding: 20px;
  object-fit: contain;
`



// WEBPACK FOOTER //
// /src/components/marketing/PartnerSection.js